import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, withCtx as _withCtx, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-bff763e2"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "min-height": "100%"
  }
};
const _hoisted_2 = {
  class: "homebox clearfix"
};
const _hoisted_3 = {
  class: "owin-height"
};
const _hoisted_4 = {
  class: "course-top"
};
const _hoisted_5 = {
  class: "course-main-title"
};
const _hoisted_6 = {
  key: 0,
  class: "line-icon"
};
const _hoisted_7 = {
  key: 1,
  class: "text"
};
const _hoisted_8 = {
  key: 2,
  class: "show-classify"
};
const _hoisted_9 = {
  class: "classify-box"
};
const _hoisted_10 = ["onClick", "title"];

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-arrow-down"
}, null, -1));

const _hoisted_12 = {
  class: "course-wrapper"
};
const _hoisted_13 = {
  class: "category-list"
};

const _hoisted_14 = /*#__PURE__*/_createTextVNode("归属学院");

const _hoisted_15 = {
  class: "subject-list"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  class: "popover-category"
};
const _hoisted_18 = {
  class: "category-title"
};
const _hoisted_19 = {
  class: "count"
};

const _hoisted_20 = /*#__PURE__*/_createTextVNode("所属学期");

const _hoisted_21 = {
  class: "category-title"
};
const _hoisted_22 = {
  class: "count"
};

const _hoisted_23 = /*#__PURE__*/_createTextVNode("课程成果");

const _hoisted_24 = {
  class: "category-title"
};
const _hoisted_25 = {
  class: "count"
};

const _hoisted_26 = /*#__PURE__*/_createTextVNode("所属学科");

const _hoisted_27 = {
  class: "subject-list"
};
const _hoisted_28 = ["onClick"];
const _hoisted_29 = {
  class: "popover-category"
};
const _hoisted_30 = {
  class: "category-title"
};
const _hoisted_31 = {
  class: "count"
};
const _hoisted_32 = {
  class: "course-filter"
};
const _hoisted_33 = {
  class: "course-total"
};

const _hoisted_34 = /*#__PURE__*/_createTextVNode(" 找到约 ");

const _hoisted_35 = /*#__PURE__*/_createTextVNode(" 条相关结果 ");

const _hoisted_36 = {
  class: "course-sort"
};
const _hoisted_37 = {
  key: 0,
  class: "iconfont icon-zonghepaixu sort-icon"
};
const _hoisted_38 = {
  key: 1,
  class: "iconfont icon-paixu sort-icon"
};
const _hoisted_39 = {
  key: 2,
  class: "iconfont icon-jiangxu sort-icon"
};
const _hoisted_40 = {
  key: 1,
  class: "no-data"
};
const _hoisted_41 = {
  key: 1,
  class: "no-data"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Head = _resolveComponent("Head");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_popover = _resolveComponent("el-popover");

  const _component_el_menu_item = _resolveComponent("el-menu-item");

  const _component_el_sub_menu = _resolveComponent("el-sub-menu");

  const _component_el_menu = _resolveComponent("el-menu");

  const _component_el_affix = _resolveComponent("el-affix");

  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

  const _component_el_dropdown = _resolveComponent("el-dropdown");

  const _component_CourseCard = _resolveComponent("CourseCard");

  const _component_Empty = _resolveComponent("Empty");

  const _component_SpocCard = _resolveComponent("SpocCard");

  const _component_el_pagination = _resolveComponent("el-pagination");

  const _component_Footer = _resolveComponent("Footer");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_Head, {
    menuCode: $data.courseType == '1' ? '10401' : '10402',
    menuInfo: $data.menuInfo,
    "onUpdate:menuInfo": _cache[0] || (_cache[0] = $event => $data.menuInfo = $event),
    onSpocName: $options.SpocName,
    onGetUserInfo: $options.getUserInfo
  }, null, 8, ["menuCode", "menuInfo", "onSpocName", "onGetUserInfo"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [$data.classify_flag !== '1' ? (_openBlock(), _createElementBlock("div", _hoisted_6)) : _createCommentVNode("", true), $data.classify_flag !== '1' ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString($data.menuInfo.nav_name) + " ", 1)) : _createCommentVNode("", true), $data.classify_flag == '1' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
    class: _normalizeClass(["show-list", $data.hiddenMoreClass && 'hidden'])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.classifyList, item => {
    return _openBlock(), _createElementBlock("span", {
      class: _normalizeClass(["list-item text-overflow", $data.classifyId === item.id && 'active']),
      key: item.id,
      onClick: $event => $options.searchCourseList(item.id),
      title: item.name
    }, _toDisplayString(item.name), 11, _hoisted_10);
  }), 128))], 2), $data.classifyList.length > 5 ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: _normalizeClass(["show-more-btn", !$data.hiddenMoreClass && 'hidden']),
    onClick: _cache[1] || (_cache[1] = $event => $data.hiddenMoreClass = !$data.hiddenMoreClass)
  }, [_createTextVNode(_toDisplayString($data.hiddenMoreClass ? '展开' : '收起') + " ", 1), _hoisted_11], 2)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]), _createVNode(_component_el_input, {
    modelValue: $data.courseName,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.courseName = $event),
    size: "default",
    class: "search-input",
    onKeyup: _withKeys($options.handleSearch, ["enter"]),
    placeholder: "搜索课程名称"
  }, {
    suffix: _withCtx(() => [_createElementVNode("i", {
      class: "iconfont icon-sousuo search-icon",
      onClick: _cache[2] || (_cache[2] = (...args) => $options.handleSearch && $options.handleSearch(...args))
    })]),
    _: 1
  }, 8, ["modelValue", "onKeyup"])]), _createElementVNode("div", _hoisted_12, [$data.organ_flag == 1 || $data.results_flag == 1 || $data.subject_flag == 1 || $data.term_flag == 1 ? (_openBlock(), _createBlock(_component_el_affix, {
    key: 0,
    offset: 0
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [$data.organ_flag == 1 ? (_openBlock(), _createBlock(_component_el_menu, {
      key: 0,
      "default-active": $data.searchInfo.collegeId,
      "default-openeds": ['2']
    }, {
      default: _withCtx(() => [_createVNode(_component_el_sub_menu, {
        index: "2"
      }, {
        title: _withCtx(() => [_hoisted_14]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.categoryList, (item, index) => {
          return _withDirectives((_openBlock(), _createBlock(_component_el_menu_item, {
            class: _normalizeClass(["category-item", $data.searchInfo.collegeId == item.id ? 'active-tag' : '']),
            index: item.id + '',
            key: item.id,
            onClick: $event => $options.collegeChange(item)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_popover, {
              placement: "right",
              offset: 20,
              width: 400,
              trigger: "hover",
              "show-arrow": false,
              disabled: item.children && item.children.length ? false : true
            }, {
              reference: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_createElementVNode("span", _hoisted_18, _toDisplayString(item.organName), 1), _createElementVNode("span", _hoisted_19, "(" + _toDisplayString(item.courseNum) + ")", 1)])]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, subject => {
                return _openBlock(), _createElementBlock("span", {
                  class: "subject-item",
                  key: subject.id,
                  onClick: $event => $options.twoCollegeChange(subject)
                }, _toDisplayString(subject.organName) + "(" + _toDisplayString(subject.courseNum) + ") ", 9, _hoisted_16);
              }), 128))])]),
              _: 2
            }, 1032, ["disabled"])]),
            _: 2
          }, 1032, ["class", "index", "onClick"])), [[_vShow, $data.showMoreCollege || index < 6]]);
        }), 128)), $data.categoryList.length > 6 ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "category-btn",
          onClick: _cache[4] || (_cache[4] = (...args) => $options.toggleShowCollege && $options.toggleShowCollege(...args))
        }, _toDisplayString($data.showMoreCollege ? '-' : '+'), 1)) : _createCommentVNode("", true)]),
        _: 1
      })]),
      _: 1
    }, 8, ["default-active"])) : _createCommentVNode("", true), $data.courseType == '2' && $data.term_flag == 1 ? (_openBlock(), _createBlock(_component_el_menu, {
      key: 1,
      "default-active": $data.searchInfo.termId,
      "default-openeds": ['4']
    }, {
      default: _withCtx(() => [_createVNode(_component_el_sub_menu, {
        index: "4"
      }, {
        title: _withCtx(() => [_hoisted_20]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.termList, (item, index) => {
          return _withDirectives((_openBlock(), _createBlock(_component_el_menu_item, {
            class: _normalizeClass(["category-item", $data.searchInfo.termId == item.semester_id && $data.searchInfo.schoolyearId == item.schoolyear_id ? 'active-tag' : '']),
            index: item.semester_id + '',
            key: item.semester_id,
            onClick: $event => $options.termChange(item)
          }, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_21, _toDisplayString(item.schoolyear + ' ' + item.semester), 1), _createElementVNode("span", _hoisted_22, "(" + _toDisplayString(item.course_num) + ")", 1)]),
            _: 2
          }, 1032, ["class", "index", "onClick"])), [[_vShow, $data.showMoreTerm || index < 6]]);
        }), 128)), $data.termList.length > 6 ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "category-btn",
          onClick: _cache[5] || (_cache[5] = (...args) => $options.toggleShowTerm && $options.toggleShowTerm(...args))
        }, _toDisplayString($data.showMoreTerm ? '-' : '+'), 1)) : _createCommentVNode("", true)]),
        _: 1
      })]),
      _: 1
    }, 8, ["default-active"])) : _createCommentVNode("", true), $data.results_flag == 1 ? (_openBlock(), _createBlock(_component_el_menu, {
      key: 2,
      "default-active": $data.searchInfo.courseResultsId,
      "default-openeds": ['1']
    }, {
      default: _withCtx(() => [_createVNode(_component_el_sub_menu, {
        index: "1"
      }, {
        title: _withCtx(() => [_hoisted_23]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.achievementKindList, (item, index) => {
          return _withDirectives((_openBlock(), _createBlock(_component_el_menu_item, {
            class: _normalizeClass(["category-item", $data.searchInfo.courseResultsId == item.id ? 'active-tag' : '']),
            index: item.id + '',
            key: item.id,
            onClick: $event => $options.courseResultChange(item)
          }, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_24, _toDisplayString(item.name), 1), _createElementVNode("span", _hoisted_25, "(" + _toDisplayString(item.course_num) + ")", 1)]),
            _: 2
          }, 1032, ["class", "index", "onClick"])), [[_vShow, $data.showMoreCourseKind || index < 6]]);
        }), 128)), $data.achievementKindList.length > 6 ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "category-btn",
          onClick: _cache[6] || (_cache[6] = (...args) => $options.toggleShowCourseKind && $options.toggleShowCourseKind(...args))
        }, _toDisplayString($data.showMoreCourseKind ? '-' : '+'), 1)) : _createCommentVNode("", true)]),
        _: 1
      })]),
      _: 1
    }, 8, ["default-active"])) : _createCommentVNode("", true), $data.subject_flag == 1 ? (_openBlock(), _createBlock(_component_el_menu, {
      key: 3,
      "default-active": $data.searchInfo.subjectId,
      "default-openeds": ['3']
    }, {
      default: _withCtx(() => [_createVNode(_component_el_sub_menu, {
        index: "3"
      }, {
        title: _withCtx(() => [_hoisted_26]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.subjectList, (item, index) => {
          return _withDirectives((_openBlock(), _createBlock(_component_el_menu_item, {
            class: _normalizeClass(["category-item", $data.searchInfo.subjectId == item.id ? 'active-tag' : '']),
            index: item.id + '',
            key: item.id,
            onClick: $event => $options.oneSubjectChange(item)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_popover, {
              placement: "right",
              offset: 20,
              width: 400,
              trigger: "hover",
              "show-arrow": false,
              disabled: item.children && item.children.length ? false : true
            }, {
              reference: _withCtx(() => [_createElementVNode("div", _hoisted_29, [_createElementVNode("span", _hoisted_30, _toDisplayString(item.subjectName), 1), _createElementVNode("span", _hoisted_31, "(" + _toDisplayString(item.courseNum) + ")", 1)])]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_27, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, subject => {
                return _openBlock(), _createElementBlock("span", {
                  class: "subject-item",
                  key: subject.id,
                  onClick: $event => $options.twoSubjectChange(subject)
                }, _toDisplayString(subject.subjectName) + "(" + _toDisplayString(subject.courseNum) + ") ", 9, _hoisted_28);
              }), 128))])]),
              _: 2
            }, 1032, ["disabled"])]),
            _: 2
          }, 1032, ["class", "index", "onClick"])), [[_vShow, $data.showMoreSubject || index < 6]]);
        }), 128)), $data.subjectList.length > 6 ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "category-btn",
          onClick: _cache[7] || (_cache[7] = (...args) => $options.toggleShowSubject && $options.toggleShowSubject(...args))
        }, _toDisplayString($data.showMoreSubject ? '-' : '+'), 1)) : _createCommentVNode("", true)]),
        _: 1
      })]),
      _: 1
    }, 8, ["default-active"])) : _createCommentVNode("", true)])]),
    _: 1
  })) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass(["course-box", {
      'course-box-no': $data.organ_flag == 2 && $data.results_flag == 2 && $data.subject_flag == 2
    }])
  }, [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_hoisted_34, _createElementVNode("span", null, _toDisplayString($data.pageInfo.rows), 1), _hoisted_35]), _createElementVNode("div", _hoisted_36, [_createVNode(_component_el_dropdown, {
    trigger: "hover",
    "append-to-body": false,
    "show-arrow": false
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.sortTypeList, (item, index) => {
        return _openBlock(), _createBlock(_component_el_dropdown_item, {
          key: item.name,
          onClick: $event => $options.handleSort(item, index)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
          _: 2
        }, 1032, ["onClick"]);
      }), 128))]),
      _: 1
    })]),
    default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($data.searchInfo.sortName), 1)]),
    _: 1
  }), $data.searchInfo.sortNum == 1 ? (_openBlock(), _createElementBlock("i", _hoisted_37)) : $data.searchInfo.sortNum == 2 ? (_openBlock(), _createElementBlock("i", _hoisted_38)) : (_openBlock(), _createElementBlock("i", _hoisted_39))])]), _createElementVNode("div", null, [$data.courseType == '1' && $data.courseList.length ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["course-list", $data.organ_flag == 2 && $data.results_flag == 2 && $data.subject_flag == 2 ? 'course-list-no' : ''])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.courseList, course => {
    return _openBlock(), _createBlock(_component_CourseCard, {
      userInfo: $data.userInfo,
      "course-data": course,
      resultMap: $data.resultMap,
      key: course.courseId,
      authType: $data.authType,
      showResultTag: $data.showResultTag
    }, null, 8, ["userInfo", "course-data", "resultMap", "authType", "showResultTag"]);
  }), 128))], 2)) : _createCommentVNode("", true), $data.courseType == 1 && !$data.courseList.length ? (_openBlock(), _createElementBlock("div", _hoisted_40, [_createVNode(_component_Empty)])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [$data.courseType == '2' && $data.courseList.length ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["course-list", $data.organ_flag == 2 && $data.results_flag == 2 && $data.subject_flag == 2 && $data.term_flag == 2 ? 'course-list-no' : ''])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.courseList, course => {
    return _openBlock(), _createBlock(_component_SpocCard, {
      userInfo: $data.userInfo,
      info: course,
      key: course.courseId,
      authType: $data.authType,
      showResultTag: $data.showResultTag,
      resultMap: $data.resultMap
    }, null, 8, ["userInfo", "info", "authType", "showResultTag", "resultMap"]);
  }), 128))], 2)) : _createCommentVNode("", true), $data.courseType == '2' && !$data.courseList.length ? (_openBlock(), _createElementBlock("div", _hoisted_41, [_createVNode(_component_Empty)])) : _createCommentVNode("", true)]), $data.pageInfo.rows > $data.pageInfo.pageLimit ? (_openBlock(), _createBlock(_component_el_pagination, {
    key: 0,
    class: "course-pagination",
    background: "",
    layout: "prev, pager, next",
    "prev-text": "上一页",
    "next-text": "下一页",
    "page-size": $data.pageInfo.pageLimit,
    onCurrentChange: $options.pageIndexChange,
    "current-page": $data.pageInfo.pageIndex,
    total: 0 || $data.pageInfo.rows
  }, null, 8, ["page-size", "onCurrentChange", "current-page", "total"])) : _createCommentVNode("", true)], 2)])]), _createVNode(_component_Footer)])]);
}